export function addCurrent(scheduleworkhour) {
    return {
        type: 'ADD_CURRENT',
        scheduleworkhour,
    }
}
